/**
 * Editor client workspace paths:
 *   <workspaceRoot>/<Client Name>/<Book Title>/<Version>/book.sbk
 */

export const EDITOR_WORKSPACE_STORAGE_KEY = "jw_desktop_v2_editor_workspace_root";
export const DEFAULT_EDITOR_WORKSPACE_FOLDER_NAME = "JustWrite/Clients";

export function sanitizePathSegment(name: string): string {
  const cleaned = name
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "")
    .replace(/\s+/g, " ")
    .replace(/[. ]+$/g, "");
  return cleaned || "Untitled";
}

export function editorBookDir(params: {
  workspaceRoot: string;
  clientName: string;
  bookTitle: string;
  versionName: string;
}): string {
  const root = params.workspaceRoot.replace(/[/\\]+$/, "");
  return [
    root,
    sanitizePathSegment(params.clientName),
    sanitizePathSegment(params.bookTitle),
    sanitizePathSegment(params.versionName),
  ].join("/");
}

export function editorBookFilePath(params: {
  workspaceRoot: string;
  clientName: string;
  bookTitle: string;
  versionName: string;
  fileName?: string;
}): string {
  const dir = editorBookDir(params);
  const file = sanitizePathSegment(params.fileName || params.bookTitle).replace(/\s+/g, "-");
  const base = file.toLowerCase().endsWith(".sbk") ? file : `${file}.sbk`;
  return `${dir}/${base}`;
}

export function readEditorWorkspaceRoot(): string | null {
  try {
    const v = localStorage.getItem(EDITOR_WORKSPACE_STORAGE_KEY);
    return typeof v === "string" && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function writeEditorWorkspaceRoot(path: string | null): void {
  try {
    if (!path || !path.trim()) localStorage.removeItem(EDITOR_WORKSPACE_STORAGE_KEY);
    else localStorage.setItem(EDITOR_WORKSPACE_STORAGE_KEY, path.trim());
  } catch {
    /* ignore */
  }
}
